var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* NO販売店情報(登録更新画面)  */
import React, { useEffect, useCallback, useState, useMemo } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowzerBack } from '../../BrowzerBack';
import { no_store_params_init, loding_close_timmer } from '../../Const';
import { scrollPageTop } from '../../Scroll';
import InputSelect from '../../molecules/maintenance/InputSelect';
import InputText from '../../molecules/maintenance/InputText';
import Label from '../../molecules/maintenance/label';
import { useToggle } from '../../hooks/ToggleHooks';
import { navigationToNoStoreLint } from './StoreCommon';
import ModalTemplate from '../../molecules/ModalTemplate';
import ModalConfirm from '../../molecules/ModalConfirm';
import LoadingModal from '../../organisms/LoadingModal';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '../../Common';
import { Button, Modal } from 'react-bootstrap';
import { convertLine, convertUpperCaseAlphaNumericSymbol } from '../../Convert';
var NoStoreCreate = function (_a) {
    var organizations_id = _a.organizations_id;
    var _b = useToggle(false), is_loading = _b[0], toggleIsLoading = _b[1];
    var _c = useToggle(false), show_update = _c[0], toggleShowUpdate = _c[1];
    var _d = useToggle(false), show_delete = _d[0], toggleShowDelete = _d[1];
    var _e = useToggle(false), show_completed = _e[0], toggleShowCompleted = _e[1];
    var _f = useToggle(false), delete_completed = _f[0], toggleDeleteCompleted = _f[1];
    // 言語
    var _g = useTranslation(), t = _g.t, i18n = _g.i18n;
    // 各項目のパラメータ
    var _h = useState(no_store_params_init), no_store_params = _h[0], setNoStoreParams = _h[1];
    // NO統括リスト
    var _j = useState([]), no_supervision_list = _j[0], setNoSupervisionList = _j[1];
    // D-CODEリスト
    var _k = useState([]), d_code_list = _k[0], setDCodeList = _k[1];
    // Ajaxリクエスト中フラグ
    var _l = useState(false), is_connecting = _l[0], setIsConnecting = _l[1];
    // バリデーションメッセージ
    var _m = useState([]), messages = _m[0], setMessages = _m[1];
    //エラーモーダル管理
    var _o = useToggle(false), modal_error_show = _o[0], toggleModalErrorShow = _o[1];
    //例外メッセージ
    var _p = useState(''), modal_error_message = _p[0], setModalErrorMessage = _p[1];
    //選択したNO統括
    var _q = useState(''), selected_no_supervision = _q[0], setSelectedNoSuperVision = _q[1];
    //更新フラグ
    var is_update = typeof organizations_id !== 'undefined' && organizations_id !== null;
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        // 言語変更
        i18n.changeLanguage(getLanguage());
        var init = function () { return __awaiter(void 0, void 0, void 0, function () {
            var url, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        //ローディング画面表示
                        toggleIsLoading();
                        setIsConnecting(true);
                        url = typeof organizations_id !== 'undefined' && organizations_id !== null
                            ? "" + location.origin + process.env.MIX_MOCK_URL + "/staff/no_store/show/init/" + organizations_id
                            : "" + location.origin + process.env.MIX_MOCK_URL + "/staff/no_store/show/init";
                        return [4 /*yield*/, axios.get(url)];
                    case 1:
                        response = _a.sent();
                        setNoStoreParams(response.data.init);
                        setNoSupervisionList(response.data.option.no_supervision_list);
                        setDCodeList(response.data.option.d_code_list);
                        // 画面表示直後は、NO統括は未選択のためD-CODEの選択肢は空
                        setSelectedNoSuperVision('');
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        //画面トップに遷移
                        scrollPageTop();
                        //ローディング画面非表示
                        toggleIsLoading();
                        setIsConnecting(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        //初期表示データを取得する。
        init();
    }, []);
    // NO統括の選択に応じて、選択可能なD-CODEの組織をそのNO統括の配下のみに絞り込む
    var disp_d_code_list = useMemo(function () {
        if (selected_no_supervision === '')
            return []; // NO統括が未選択の場合は、D-CODEも未選択のみとする
        return d_code_list.filter(function (d_code_org) { return d_code_org.parent === selected_no_supervision; });
    }, [selected_no_supervision]);
    /**
     * 販売店情報更新処理
     */
    var update = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2, error_message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    toggleIsLoading();
                    toggleShowUpdate();
                    setMessages([]);
                    return [4 /*yield*/, axios.put("" + location.origin + process.env.MIX_MOCK_URL + "/staff/no_store/update", no_store_params)];
                case 1:
                    response = _a.sent();
                    toggleShowCompleted();
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    error_message = error_2.response.data.message;
                    setModalErrorMessage(getMessageAll(error_message));
                    // バリデーション検知時
                    if (error_2.response.status === 422) {
                        setMessages(error_message);
                    }
                    toggleModalErrorShow();
                    console.log(error_2);
                    return [3 /*break*/, 4];
                case 3:
                    toggleIsLoading();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [is_connecting, no_store_params]);
    /**
     * 販売店情報登録処理
     */
    var store = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3, error_message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    toggleIsLoading();
                    toggleShowUpdate();
                    setMessages([]);
                    return [4 /*yield*/, axios.post("" + location.origin + process.env.MIX_MOCK_URL + "/staff/no_store/store", no_store_params)];
                case 1:
                    response = _a.sent();
                    toggleShowCompleted();
                    return [3 /*break*/, 4];
                case 2:
                    error_3 = _a.sent();
                    error_message = error_3.response.data.message;
                    setModalErrorMessage(getMessageAll(error_message));
                    // バリデーション検知時
                    if (error_3.response.status === 422) {
                        setMessages(error_message);
                    }
                    toggleModalErrorShow();
                    console.log(error_3);
                    return [3 /*break*/, 4];
                case 3:
                    toggleIsLoading();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [is_connecting, no_store_params]);
    /**
     * 販売店情報削除処理
     */
    var delete_no_store = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_4, error_message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    toggleIsLoading();
                    toggleShowDelete();
                    setMessages([]);
                    return [4 /*yield*/, axios.delete("" + location.origin + process.env.MIX_MOCK_URL + "/staff/no_store/delete/" + no_store_params.id)];
                case 1:
                    response = _a.sent();
                    toggleDeleteCompleted();
                    return [3 /*break*/, 4];
                case 2:
                    error_4 = _a.sent();
                    error_message = error_4.response.data.message;
                    setModalErrorMessage(getMessageAll(error_message));
                    // バリデーション検知時
                    toggleModalErrorShow();
                    console.log(error_4);
                    return [3 /*break*/, 4];
                case 3:
                    toggleIsLoading();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [is_connecting, no_store_params]);
    /**
     * ショップ因子履歴画面に遷移する。
     */
    var transitionToNoStoreFactoryHistory = function () {
        try {
            toggleIsLoading();
            var url = "" + location.origin + process.env.MIX_MOCK_URL + "/staff/no_store/factor/history/" + no_store_params.id;
            location.href = url;
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setTimeout(function () { return toggleIsLoading(); }, loding_close_timmer);
        }
    };
    /**
     * バリデーションメッセージを取得する
     * @param keys 取得キー
     * @returns バリデーションメッセージ
     */
    var getMessage = function (keys) {
        // バリデーションメッセージ取得
        var msg_list = [];
        keys.map(function (key) {
            messages === null || messages === void 0 ? void 0 : messages.map(function (msg) {
                if (msg.key === key) {
                    msg_list.push(msg.message);
                }
            });
        });
        // 重複を除去した配列を返す
        var msg_list_dupl = msg_list.filter(function (x, i, self) {
            return self.indexOf(x) === i;
        });
        // 配列内のメッセージを結合した値を返却
        return msg_list_dupl.join('\n');
    };
    /**
     * 店舗情報パラメータの更新
     *
     * @param event
     * @return void
     */
    var handleChangeStoreParams = useCallback(function (event) {
        var _a = event.currentTarget, name = _a.name, value = _a.value;
        // NO統括の選択に応じて、選択可能なD-CODE組織を絞り込む
        var no_supervision_select = document.getElementById('no-supervision');
        if (no_supervision_select instanceof HTMLSelectElement) {
            var no_supervision_cd = no_supervision_select.value;
            setSelectedNoSuperVision(no_supervision_cd);
        }
        else {
            setSelectedNoSuperVision('');
        }
        setNoStoreParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[name] = value, _a));
        });
    }, [setNoStoreParams]);
    /**
     * 店舗情報パラメータのフォーカスアウト時
     * 全角英数を半角英数にし、小文字を大文字に変換する
     *
     * @param event
     * @return void
     */
    var handleChangeOnBlur = useCallback(function (event) {
        var _a = event.currentTarget, name = _a.name, value = _a.value;
        var convert_value = convertUpperCaseAlphaNumericSymbol(value);
        setNoStoreParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[name] = convert_value, _a));
        });
    }, [setNoStoreParams]);
    /**
     * バリデーションメッセージを取得する
     * @returns バリデーションメッセージ
     */
    var getMessageAll = function (messages) {
        // バリデーションメッセージ取得
        var msg_list = messages === null || messages === void 0 ? void 0 : messages.map(function (msg) { return msg.message; });
        // 重複を除去した配列を返す
        var msg_list_dupl = msg_list.filter(function (x, i, self) {
            return self.indexOf(x) === i;
        });
        // 配列内のメッセージを結合した値を返却
        return msg_list_dupl.join('\n');
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "my-2" },
                React.createElement("div", { className: "col-md-12 col-sm-10" },
                    React.createElement("div", { className: "detaile-header" },
                        React.createElement("div", { className: "d-flex justify-content-between" },
                            React.createElement("div", { className: "btn-group" },
                                React.createElement("button", { className: "btn btn-main-color btn-main-size", disabled: false, onClick: navigationToNoStoreLint }, "\u623B\u308B"),
                                React.createElement("button", { className: "btn btn-main-color btn-main-size", disabled: false, onClick: toggleShowUpdate }, "" + (is_update ? '更新実行' : '登録実行'))),
                            React.createElement("button", { className: "btn btn-main-color btn-main-size", disabled: false, onClick: transitionToNoStoreFactoryHistory, hidden: !is_update }, "\u56E0\u5B50\u8868\u793A"),
                            React.createElement("div", { className: "btn-group" },
                                React.createElement("button", { className: "btn btn-main-color btn-main-size ml-auto", disabled: false, onClick: toggleShowDelete, hidden: !is_update }, "\u524A\u9664")))))),
            React.createElement(Label, { title: "" }),
            React.createElement("div", { id: "detail" },
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "detail-container" },
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" }, is_update ? (React.createElement(React.Fragment, null,
                                React.createElement("span", { className: "detail-criteria-head" }, "NO統括"),
                                React.createElement("div", { className: "detail-form-input" }, no_store_params.no_supervision))) : (React.createElement(InputSelect, { id: "no-supervision", title: "NO\u7D71\u62EC", class_name: "detail-form-input", name: "no_supervision", value: no_store_params.no_supervision, handleChange: handleChangeStoreParams, options: no_supervision_list, help_message: "", valid_message: getMessage(['no_supervision']), t: t })))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" }, is_update ? (React.createElement(React.Fragment, null,
                                React.createElement("span", { className: "detail-criteria-head" }, "D-Code"),
                                React.createElement("div", { className: "detail-form-input" }, no_store_params.parent_cd))) : (React.createElement(InputSelect, { id: "d-code", title: "D-Code", class_name: "detail-form-input", name: "parent_cd", value: no_store_params.parent_cd, handleChange: handleChangeStoreParams, options: disp_d_code_list, help_message: "", valid_message: getMessage(['parent_cd']), t: t })))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "no-cd", name: "no_cd", title: "\u8CA9\u58F2\u5E97\u30B3\u30FC\u30C9", class_name: "detail-form-input", value: no_store_params.no_cd, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['no_cd']), disabled: is_update, onBlur: handleChangeOnBlur }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "no-name", name: "no_name", title: "\u8CA9\u58F2\u5E97\u540D", class_name: "detail-form-input", value: no_store_params.no_name, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['no_name']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "country", name: "country", title: "\u56FD", class_name: "detail-form-input", value: no_store_params.country, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['country']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "city", name: "city", title: "\u90FD\u5E02", class_name: "detail-form-input", value: no_store_params.city, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['city']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "create-user", name: "create_user", title: "\u4F5C\u6210\u8005", class_name: "detail-form-input-small", value: no_store_params.create_user, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['create_user']), disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "created-at", name: "created_at", title: "\u4F5C\u6210\u65E5\u6642", class_name: "detail-form-input-small", value: no_store_params.created_at, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['created_at']), disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "update-user", name: "update_user", title: "\u66F4\u65B0\u8005", class_name: "detail-form-input-small", value: no_store_params.update_user, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['update_user']), disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "updated-at", name: "updated_at", title: "\u66F4\u65B0\u65E5\u6642", class_name: "detail-form-input-small", value: no_store_params.updated_at, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['updated_at']), disabled: true }))))))),
        React.createElement(ModalTemplate, { show: show_update, ClickCallBackNo: toggleShowUpdate, ClickCallBackYes: is_update ? update : store, title: '確認', body: (is_update ? '更新' : '登録') + "\u3057\u307E\u3059\u3002\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F", t: t }),
        React.createElement(ModalTemplate, { show: show_delete, ClickCallBackNo: toggleShowDelete, ClickCallBackYes: delete_no_store, title: '確認', body: "\u524A\u9664\u3057\u307E\u3059\u3002\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F", t: t }),
        React.createElement(ModalConfirm, { show: show_completed, title: '完了', body: (is_update ? '更新' : '登録') + "\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002", clickCallBackConfirm: navigationToNoStoreLint }),
        React.createElement(ModalConfirm, { show: delete_completed, title: "\u5B8C\u4E86", body: "\u524A\u9664\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002", clickCallBackConfirm: navigationToNoStoreLint }),
        React.createElement(Modal, { show: modal_error_show, onHide: function () { } },
            React.createElement(Modal.Body, { className: "dialog-body" },
                React.createElement("div", { className: "paragraph" }, convertLine(modal_error_message))),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { variant: "main-color", onClick: toggleModalErrorShow }, "OK"))),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('no-store-create')) {
    var organizations_id = document
        .getElementById('no-store-create')
        .getAttribute('organizations_id');
    render(React.createElement(NoStoreCreate, { organizations_id: organizations_id }), document.getElementById('no-store-create'));
}
